// project import
// import getColors from "../utils/getColors";
// import getShadow from '../utils/getShadow';

// ==============================|| OVERRIDES - INPUT BORDER & SHADOWS ||============================== //
//
// function getColor({variant, theme}) {
//     const colors = getColors(theme, variant);
//     const {light} = colors;
//
//     const shadows = getShadow(theme, `${variant}`);
//
//     return {
//         '&:hover .MuiOutlinedInput-notchedOutline': {
//             borderColor: '#F6F6F6'
//         },
//         '&.Mui-focused': {
//             boxShadow: shadows,
//             '& .MuiOutlinedInput-notchedOutline': {
//                 border: `1px solid #F6F6F6`
//             }
//         }
//     };
// }

// ==============================|| OVERRIDES - OUTLINED INPUT ||============================== //

export default function FilledInput(theme) {
	return {
		MuiFilledInput: {
			defaultProps: {
				disableUnderline: true
			},
			styleOverrides: {
				root: {
					borderRadius: '12px',
					padding: '10px 24px 10px 16px',
					fontSize: '16px',
					lineHeight: '24px',
					backgroundColor: '#F6F6F6',
					WebkitTextFillColor: theme.palette.primary[800],
					'&.Mui-disabled': {
						backgroundColor: '#F6F6F6',
						color: theme.palette.primary[800],
						WebkitTextFillColor: 'initial!important',
					},
					'&.Mui-focused': {
						backgroundColor: '#F6F6F6',
					},
					'&:hover': {
						backgroundColor: '#F6F6F6',
					},
				},
				input: {
					maxHeight: '62px',
					padding: '10px 24px 10px 16px',
					color: theme.palette.primary[800],
					WebkitTextFillColor: 'initial!important',
					backgroundColor: '#F6F6F6',
				},
				inputMultiline: {
					padding: '10px 24px 10px 16px',
					maxHeight: '127px',
					color: theme.palette.primary[800],
					WebkitTextFillColor: 'initial!important',
				},
				autocomplete: {
					padding: '14px 24px 10px 16px',
				},
				select: {
					padding: '10px 24px 10px 16px',
				}
			}
		}
	}
}
